<template>
  <el-drawer
    class="edit-drawer"
    :visible.sync="dialogVisible"
    size="85%"
    :wrapperClosable="false"
    :show-close="false"
    :modal="false"
    :with-header="false"
    @close="handleClose"
  >
    <div class="image-editor-container" v-loading="loading" v-if="showIframe">
      <iframe
        ref="editorIframe"
        name="imageEditor"
        title="图片编辑器"
        :src="iframeUrl"
        width="100%"
        height="100%"
        frameborder="0"
        allow="clipboard-read; clipboard-write"
      ></iframe>
    </div>
    <div slot="footer" class="drawer-footer">
      <el-button @click="handleClose">关闭</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { getImgEditorOrigin } from '@/utils/domainHelper';
import OSSClient from '@/components/Uploads/OSS-client.js';
export default {
  name: 'ProdImageEditorDrawer',
  data() {
    return {
      dialogVisible: false,
      loading: true,
      iframeUrl: `${getImgEditorOrigin()}/#/?mtType=local`,
      showIframe: false,
      _loaded: false,
      _pendingImportSingle: null,
      _pendingImportBatch: null,
      // 公共参数（可被覆盖）
      callbackParams: {
        shopId: '',
        sid: '',
        apiVersion: 'v2',
        platform: 'dy',
        metaImg: undefined,
        langSizeCheck: undefined,
        json: undefined,
        unNetwork: false,
        netWorkCookie: document.cookie,
        downloadMode: 'message',
        companyId: '',
        loginId: '',
      },
      targetOrigin: getImgEditorOrigin()
    };
  },
  methods: {
    /**
     * 从项目全局状态直接获取并设置 companyId 与 loginId
     * 优先级：store.userInfo > localStorage.userinfo > RC.user
     */
    ensureUserIds() {
      try {
        const storeInfo = (this.$store && this.$store.getters && this.$store.getters.userInfo) || {};
        const ls = window.localStorage.getItem('userinfo');
        const localInfo = ls ? JSON.parse(ls) : {};
        const rcInfo = (window.RC && window.RC.user && typeof window.RC.user.get === 'function') ? window.RC.user.get() : {};

        const companyId = storeInfo.companyId || localInfo.companyId || rcInfo.companyId || '';
        const loginId = storeInfo.id || localInfo.id || rcInfo.id || '';

        if (companyId || loginId) {
          this.setEditorParams({
            companyId: companyId || this.callbackParams.companyId,
            loginId: loginId || this.callbackParams.loginId,
          });
        }
      } catch (e) {
        // 忽略兜底错误，保持组件可用
      }
    },
    /**
     * 打开对话框并初始化编辑器
     * @param {Object} payload 入参对象
     * @param {Object} payload.params 传给编辑器的公共参数（CommonCallBackParams）
     * @param {string} payload.imageUrl 单图导入的图片地址（url或base64）
     * @param {{name:string,url:string}[]} payload.srcList 批量导入的图片集合
     * @param {string|number} payload.companyId 公司ID（覆盖默认）
     * @param {string|number} payload.loginId 登录账号ID（覆盖默认）
     */
    method_open(payload = {}) {
      console.log('%c [ payload ]-96', 'font-size:13px; background:pink; color:#bf2c9f;', payload)
      this.ensureUserIds();
      this.handleShow(payload);
    },
    handleShow(payload = {}) {
      this.dialogVisible = true;
      this.loading = true;
      this._loaded = false;
      this.showIframe = true;
      this.iframeUrl = `${getImgEditorOrigin()}/#/?mtType=local`;

      // 直接从全局获取并设置 companyId/loginId
      this.ensureUserIds();

      // 合并公共参数
      if (payload.params) {
        this.setEditorParams(payload.params);
      }
      // 覆盖公司ID与登录账号ID
      if (payload.companyId != null || payload.loginId != null) {
        const companyId = payload.companyId != null ? String(payload.companyId) : this.callbackParams.companyId;
        const loginId = payload.loginId != null ? String(payload.loginId) : this.callbackParams.loginId;
        this.setEditorParams({ companyId, loginId, sid: companyId, shopId: companyId });
      }

      // 暂存待导入数据，待握手完成后发送
      this._pendingImportSingle = payload.imageUrl || null;
      this._pendingImportBatch = Array.isArray(payload.srcList)
        ? payload.srcList.map(item => ({
            ...item,
            url: (item.url || '').replace('mmecimage.cn', 'mmecimage.superboss.cc')
          }))
        : null;
    },
    /**
     * 关闭对话框
     */
    handleClose() {
      this.dialogVisible = false;
      this.showIframe = false;
      this.iframeUrl = '';
      this._loaded = false;
      this._pendingImportSingle = null;
      this._pendingImportBatch = null;
    },
    /**
     * 设置编辑器公共参数（CommonCallBackParams）
     * @param {Object} params 公共参数覆盖项
     */
    setEditorParams(params = {}) {
      this.callbackParams = Object.assign({}, this.callbackParams, params);
    },
    /**
     * 发送消息到 iframe 编辑器（单图导入）
     * @param {string} src 图片地址（url/base64）
     * @param {Object} params 覆盖公共参数
     */
    importImage(src, params = {}) {
      const iframeWindow = this.$refs.editorIframe && this.$refs.editorIframe.contentWindow;
      if (!iframeWindow || !src) return;
      const payload = Object.assign({}, this.callbackParams, params, {
        type: 'import-img',
        src,
      });
      iframeWindow.postMessage(payload, this.targetOrigin);
    },
    /**
     * 发送消息到 iframe 编辑器（批量导入）
     * @param {{name:string,url:string}[]} list 批量图片集合
     * @param {Object} params 覆盖公共参数
     */
    importImageBatch(list = [], params = {}) {
      const iframeWindow = this.$refs.editorIframe && this.$refs.editorIframe.contentWindow;
      if (!iframeWindow || !Array.isArray(list) || list.length === 0) return;
      const payload = Object.assign({}, this.callbackParams, params, {
        type: 'import-img-batch',
        src: list,
      });
      iframeWindow.postMessage(payload, this.targetOrigin);
    },
    /**
     * 接收 iframe 编辑器的消息
     * @param {MessageEvent} event 跨窗口消息事件
     */
    async eventListener(event) {
      const origin = event.origin || '';
      // 安全校验：限定来源为当前 targetOrigin 对应的域
      const eventHost = (new URL(origin).hostname || '');
      const allowedHost = (new URL(this.targetOrigin).hostname || '');
      if (eventHost !== allowedHost) return;

      // 仅在当前弹窗处于打开状态时处理消息，避免多个实例同时响应
      if (!this.dialogVisible || !this.showIframe) {
        return;
      }

      const { type } = event.data || {};
      if (type === 'meitu_load') {
        this.loading = false;
        this._loaded = true;
        // 握手后发送导入指令
        if (this._pendingImportSingle) {
          this.importImage(this._pendingImportSingle);
          this._pendingImportSingle = null;
        }
        if (this._pendingImportBatch) {
          this.importImageBatch(this._pendingImportBatch);
          this._pendingImportBatch = null;
        }
      } else if (type === 'meitu_img_close' || type === 'close') {
        this.handleClose();
      } else if (type === 'meitu_img_save') {
        try {
          const url = await this.handleSaveSingle(event.data);
          this.$emit('on-save', { url });
        } catch (e) {
          this.$emit('on-save', { url: '' });
        }
        this.handleClose();
      } else if (type === 'meitu_img_save_batch') {
        try {
          const urls = await this.handleSaveBatch(event.data);
          this.$emit('on-save-batch', { urls });
        } catch (e) {
          this.$emit('on-save-batch', { urls: [] });
        }
        this.handleClose();
      }
    },
    base64toFile(base, filename) {
      try {
        const arr = base.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const suffix = mime.split('/')[1];
        const bstr = window.atob(arr[1]);
        const n = bstr.length;
        const u8arr = new Uint8Array(n);
        for (let i = 0; i < n; i++) {
          u8arr[i] = bstr.charCodeAt(i);
        }
        return new File([u8arr], `${filename}.${suffix}`, { type: mime });
      } catch (error) {
        return null;
      }
    },
    uploadBase64ToUrl(base64) {
      return new Promise((resolve, reject) => {
        const file = this.base64toFile(base64, 'edited-image');
        if (!file) return reject(new Error('file_invalid'));
        const uid = `${Date.now()}_${Math.floor(Math.random() * 1e6)}`;
        const companyId = this.callbackParams.companyId || 'common';
        const key = `scm/${companyId}/${uid}`;
        OSSClient.getInstance().singleUpload(key, file, {
          success: (res) => resolve(res.url),
          fail: (err) => reject(err),
        });
      });
    },
    async handleSaveSingle(data = {}) {
      if (!data) return '';
      if (typeof data.url === 'string' && data.url) return data.url;
      if (typeof data.src === 'string' && data.src.startsWith('data:image')) {
        const url = await this.uploadBase64ToUrl(data.src);
        return url || '';
      }
      return '';
    },
    async handleSaveBatch(data = {}) {
      let list = [];
      if (Array.isArray(data.urls)) list = data.urls;
      else if (Array.isArray(data.srcList)) list = data.srcList;
      else if (Array.isArray(data.list)) list = data.list;
      else if (Array.isArray(data.src)) list = data.src;
      const results = [];
      for (const item of list) {
        if (typeof item === 'string') {
          if (item.startsWith('data:image')) {
            const url = await this.uploadBase64ToUrl(item).catch(() => '');
            if (url) results.push(url);
          } else {
            results.push(item);
          }
        } else if (item && (item.src || item.url)) {
          const value = typeof item.url === 'string' ? item.url : item.src;
          if (typeof value === 'string' && value.startsWith('data:image')) {
            const url = await this.uploadBase64ToUrl(value).catch(() => '');
            if (url) results.push(url);
          } else if (typeof value === 'string' && value) {
            results.push(value);
          }
        }
      }
      return results;
    },
  },
  mounted() {
    window.addEventListener('message', this.eventListener, false);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.eventListener, false);
  }
};
</script>

<style lang="scss" scoped>
.image-editor-container {
  width: 100%;
  height: 100vh;
  position: relative;
}
::v-deep .el-drawer__body {
  height: 100%;
}
.drawer-footer {
  padding: 10px 20px;
  text-align: right;
}
</style>